export var EthChainType;
(function (EthChainType) {
    EthChainType["Harmony"] = "HARMONY";
})(EthChainType || (EthChainType = {}));
//# sourceMappingURL=rpc-provider-types.js.map